import React, { Component } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { NavLink } from "react-router-dom";
import { Col } from "reactstrap";
import debounce from "lodash.debounce";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FetchServerData from "../../../../provider/FetchServerData";
import { DPTextResetPassword_Url } from "../../../../provider/ServiceUrl";
import { withRouter } from "../../../../withRouter";
import dpTextLogo from "../../../../assets/img/dptextLogo.png";
import PtsAlert from "../../ptsAlert/PtsAlert";
import "./ResetPassword.css";
import PasswordRequirementsTooltip from "../../passwordRequirementsTooltip/passwordRequirementsTooltip";

export class DPTextResetPassword extends Component {
  tenantList = [];
  constructor(props) {
    super(props);
    let email = props.email;
    let tenantList = props.tenantList;
    let tenantId = props.tenantId;
    if (props.state) {
      email = props.state.email;
      tenantList = props.state.tenantList;
      tenantId = props.state.tenantId;
    }
    this.state = {
      code: "",
      password: "",
      confirmPassword: "",
      passwordHelperText: "",
      confirmPasswordHelperText: "",
      email: email,
      tenantList: tenantList,
      tenantId: tenantId,
      showPassword: false,
      showConfirmPassword: false,
      render: false,
      error: {
        one: true,
        two: true,
        three: true,
        four: true,
        five: true,
      },
      passwordFocussed: false,
      name: "",
      value1: "",
      value1Ref: React.createRef(),
      value2: "",
      value2Ref: React.createRef(),
      value3: "",
      value3Ref: React.createRef(),
      value4: "",
      value4Ref: React.createRef(),
      value5: "",
      value5Ref: React.createRef(),
      value6: "",
      value6Ref: React.createRef(),
    };
  }

  handleCompanyChange(selectedValue) {
    this.setState({ tenantId: selectedValue });
  }
  handleEmailChange(e) {
    this.setState({ email: e.target.value });
  }

  handlePasswordChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
    if (name === "password") {
      this.debouncedValidatePassword(value, name);
    } else if (name === "confirmPassword") {
      this.debouncedValidatePassword(this.state.password, name);
    }
  };

  handleClickShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }
  debouncedValidatePassword = debounce(
    (password, name) => this.validatePassword(password, name),
    800
  );

  validatePassword = (password, name) => {
    const { confirmPassword } = this.state;
    let one = false,
      two = false,
      three = false,
      four = false,
      five = false,
      confirmPasswordHelperText = "";
    if (password.length < 12) {
      one = true;
    }
    if (!password.match(/[A-Z]/)) {
      two = true;
    }
    if (!password.match(/[a-z]/)) {
      three = true;
    }
    if (!password.match(/\d/)) {
      four = true;
    }
    if (!password.match(/\W/)) {
      five = true;
    }
    if (password !== confirmPassword) {
      confirmPasswordHelperText =
        name === "password" && confirmPassword === ""
          ? ""
          : "Passwords do not match";
    }

    if (one || two || three || four || five) {
      this.setState({
        error: { one: one, two: two, three: three, four: four, five: five },
        confirmPasswordHelperText: confirmPasswordHelperText,
        passwordHelperText: "Password requirements not met",
      });
      return;
    }

    this.setState({
      error: {},
      confirmPasswordHelperText: confirmPasswordHelperText,
      passwordHelperText: "",
    });
  };

  handleClickShowConfirmPassword() {
    this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
  }
  handlePasswordConfirmChange(e) {
    this.setState({ confirmPassword: e.target.value });
  }

  toggleFocusNewPassword = () => {
    this.setState((prevState) => {
      return { passwordFocussed: !prevState.passwordFocussed };
    });
  };

  handleVerificationCodeChange(e) {
    this.setState({ code: e.target.value });
  }

  resetPasswordLinkBackend() {
    const { value1, value2, value3, value4, value5, value6 } = this.state;
    const otpValue = `${value1}${value2}${value3}${value4}${value5}${value6}`;
    if (otpValue.length !== 6) {
      return;
    }

    if (this.state.password !== this.state.confirmPassword) {
      PtsAlert.error("Password & confirm password must match");
      return;
    }

    const postObject = {
      header: { tid: this.state.tenantId?.id },
      appuser: {
        email: this.state.email,
        credential: this.state.password,
        temppassword: otpValue,
      },
    };

    FetchServerData.callPostService(DPTextResetPassword_Url, postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          // PtsAlert.success(output.message);
          this.props.navigate({
            pathname: "/dptextSignin",
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  componentDidMount() {
    this.state.value1Ref.current.focus();
  }

  handleValueChange = (e) => {
    const { name, value } = e.target;
    if (e.key === "Backspace") {
      return;
    }
    if (value.length > 1) {
      PtsAlert.error("Please enter a single digit");
      return;
    }

    this.setState({ [name]: value });

    switch (name) {
      case "value1":
        this.value2Focus();
        this.value2Select();
        break;
      case "value2":
        this.value3Focus();
        this.value3Select();
        break;
      case "value3":
        this.value4Focus();
        this.value4Select();
        break;
      case "value4":
        this.value5Focus();
        this.value5Select();
        break;
      case "value5":
        this.value6Focus();
        this.value6Select();
        break;
      case "value6":
        break;
      default:
        break;
    }
  };

  handleKeyUp = (e) => {
    const { name, key } = e.target;
    if (key === "Enter") {
      this.verifyOTPInBackend();
    } else if (key === "ArrowLeft") {
      const map = {
        value2: this.value1Ref,
        value3: this.value2Ref,
        value4: this.value3Ref,
        value5: this.value4Ref,
        value6: this.value5Ref,
      };
      if (map[name]) map[name].current.focus();
    } else if (key === "ArrowRight") {
      const map = {
        value1: this.value2Ref,
        value2: this.value3Ref,
        value3: this.value4Ref,
        value4: this.value5Ref,
        value5: this.value6Ref,
      };
      if (map[name]) map[name].current.focus();
    }
  };

  handleKeyDown = (e) => {
    if (e.key !== "Backspace") return;

    e.preventDefault();
    const { name, value } = e.target;

    const prevMap = {
      value2: this.state.value1Ref,
      value3: this.state.value2Ref,
      value4: this.state.value3Ref,
      value5: this.state.value4Ref,
      value6: this.state.value5Ref,
    };

    if (!value) {
      const prev = prevMap[name];
      if (prev?.current) {
        prev.current.focus();
      }
      return;
    }

    this.setState({ [name]: "" });
  };

  value1Focus = () => {
    this.state.value1Ref.current.focus();
  };
  value2Focus = () => {
    this.state.value2Ref.current.focus();
  };
  value3Focus = () => {
    this.state.value3Ref.current.focus();
  };
  value4Focus = () => {
    this.state.value4Ref.current.focus();
  };
  value5Focus = () => {
    this.state.value5Ref.current.focus();
  };
  value6Focus = () => {
    this.state.value6Ref.current.focus();
  };

  value1Select = () => {
    this.state.value1Ref.current.select();
  };
  value2Select = () => {
    this.state.value2Ref.current.select();
  };
  value3Select = () => {
    this.state.value3Ref.current.select();
  };
  value4Select = () => {
    this.state.value4Ref.current.select();
  };
  value5Select = () => {
    this.state.value5Ref.current.select();
  };
  value6Select = () => {
    this.state.value6Ref.current.select();
  };

  renderInputBox = (name, ref) => {
    return (
      <Col md={2} style={{ padding: "0rem 0rem 0rem 1rem" }}>
        <input
          type="number"
          ref={this.state[ref]}
          className="form-control otpFormControlInput"
          id={"otpFormControlInput-" + name}
          maxLength="1"
          name={name}
          value={this.state[name]}
          onKeyUp={this.handleKeyUp}
          onKeyDown={this.handleKeyDown}
          onChange={this.handleValueChange}
          aria-describedby="defaultFormControlHelp"
        />
      </Col>
    );
  };

  render() {
    const { error, passwordFocussed } = this.state;
    return (
      <div className="authentication-wrapper authentication-cover">
        <div className="authentication-inner row m-0" id="signIn">
          <header
            id="dptextheader"
            className="fixed-top d-flex align-items-center"
          >
            <div className="container d-flex align-items-center justify-content-between">
              <div className="logo">
                <img
                  src={dpTextLogo}
                  alt=""
                  style={{ width: "auto", height: "60px" }}
                />
              </div>
              <nav id="navbar" className="navbar">
                <ul>
                  <li>
                    <a
                      className="nav-link scrollto"
                      href="/dptextSignin"
                      style={{ color: "#53a5ff" }}
                    >
                      Login
                    </a>
                  </li>
                  <li className="active">
                    <a
                      className="nav-link scrollto"
                      href="/dptextSignup"
                      style={{ color: "#53a5ff" }}
                    >
                      Sign Up
                    </a>
                  </li>
                </ul>
                <i className="bi bi-list mobile-nav-toggle" />
              </nav>
            </div>
          </header>
          <div className="d-flex col-12 col-lg-12 col-xl-12 align-items-center authentication-bg p-sm-5 p-4">
            <div className="w-px-400 mx-auto">
              <div className="row text-start">
                <h4>Reset Password</h4>
              </div>
              <ValidatorForm
                ref="form"
                id="formAuthentication"
                className="mb-3"
                onSubmit={this.resetPasswordLinkBackend.bind(this)}
              >
                <div className="mb-3">
                  <label className="form-label" htmlFor="multiStepsEmail">
                    User ID (email address)
                  </label>
                  <input
                    title=""
                    required
                    type="email"
                    name="multiStepsEmail"
                    value={this.state.email}
                    onChange={this.handleEmailChange.bind(this)}
                    id="multiStepsEmail"
                    className="form-control"
                    aria-label="john.doe"
                    disabled
                  />{" "}
                </div>
                <div className="mb-2">
                  <label className="form-label" htmlFor="multiStepsLastName">
                    Company Name
                  </label>
                  <input
                    title=""
                    required
                    type="text"
                    name="multiStepsCompanyname"
                    value={this.state.tenantId?.name}
                    id="multiStepsEmail"
                    className="form-control"
                    aria-label="john.doe"
                    disabled
                  />
                </div>
                <div className="mb-2">
                  <label
                    htmlFor="email"
                    className="form-label"
                    id="signupFormLabel"
                  >
                    Verification Code
                  </label>
                  <div className="d-flex col-12 col-lg-12 col-xl-12 pt-3">
                    <div className="row">
                      {this.renderInputBox("value1", "value1Ref")}
                      {this.renderInputBox("value2", "value2Ref")}
                      {this.renderInputBox("value3", "value3Ref")}
                      {this.renderInputBox("value4", "value4Ref")}
                      {this.renderInputBox("value5", "value5Ref")}
                      {this.renderInputBox("value6", "value6Ref")}
                    </div>
                  </div>
                </div>
                <div className="mb-2 form-password-toggle">
                  <label className="form-label" htmlFor="multiStepsPass">
                    Enter New Password
                    {this.state.passwordHelperText ? (
                      <PasswordRequirementsTooltip
                        error={error}
                        open={passwordFocussed}
                        style={{
                          float: "right",
                          marginTop: "-1em",
                        }}
                      />
                    ) : (
                      ""
                    )}{" "}
                  </label>
                  <div className="input-group input-group-merge">
                    <input
                      type={this.state.showPassword ? "text" : "password"}
                      id="password"
                      name="password"
                      className="form-control"
                      aria-describedby="multiStepsPass2"
                      onChange={this.handlePasswordChange.bind(this)}
                      value={this.state.password}
                      onFocus={this.toggleFocusNewPassword}
                      onBlur={this.toggleFocusNewPassword}
                      helperText={this.state.passwordHelperText}
                      error={this.state.passwordHelperText !== ""}
                    />
                    <span
                      className="input-group-text cursor-pointer"
                      id="multiStepsPass2"
                      onClick={this.handleClickShowPassword.bind(this)}
                    >
                      {this.state.showPassword ? (
                        <VisibilityIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </span>
                  </div>
                </div>
                <div className="mb-2 form-password-toggle">
                  <label className="form-label" htmlFor="multiStepsPass">
                    Confirm Password
                  </label>
                  <div className="input-group input-group-merge">
                    <input
                      id="confirmPassword"
                      name="confirmPassword"
                      className="form-control"
                      aria-describedby="multiStepsConfirmPass2"
                      value={this.state.confirmPassword}
                      type={this.state.showConfirmPassword ? "text" : "password"}
                      helperText={this.state.confirmPasswordHelperText}
                      error={this.state.confirmPasswordHelperText !== ""}
                      onChange={this.handlePasswordChange.bind(this)}
                    />
                    <span
                      className="input-group-text cursor-pointer"
                      id="multiStepsPass2"
                      onClick={this.handleClickShowConfirmPassword.bind(this)}
                    >
                      {this.state.showConfirmPassword ? (
                        <VisibilityIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </span>
                  </div>
                  {this.state.confirmPasswordHelperText && (
                    <p style={{ color: "red", fontSize: "13px" }}>
                      {this.state.confirmPasswordHelperText}
                    </p>
                  )}
                </div>
                <button className="dptextSiginButton d-grid w-100 mt-4">
                  Reset Password
                </button>
              </ValidatorForm>
              <p className="signupLink">
                <span>Already have an account?</span>&nbsp;
                <NavLink to="/dptextSignin">
                  <span>Sign In</span>
                </NavLink>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(DPTextResetPassword);
